// @flow

import React from 'react'
import { ownerEvalutionImage } from 'frontend_core/dist/helpers/image'
import HelpTooltip from 'components/molecules/room/HelpTooltip'

export type PropTypes = {
  confirmRateEvaluation: string,
  confirmRateText: string,
  replyRateEvaluation: string,
  replyRateText: string,
  replyTimeAvgEvaluation: string,
  replyTimeAvgText: string,
}

export default (props: PropTypes) => (
  <div className="space-side__owner-eval">
    <div className="space-side__owner-eval-innner row">
      <div className="space-side__owner-eval-innner-list col-xs-4">
        <h4 className="mod-evaluate__title">
          {i18n.t('page.room.evalute1')}
          <span className="mod-evaluate__help">
            <i className="fa fa-question-circle mod-evaluate__question" />
            <HelpTooltip text={i18n.t('page.room.captionOwnerEvaluation')} />
          </span>
        </h4>
        <div className="mod-evaluate__value">
          <img
            src={ownerEvalutionImage(props.confirmRateEvaluation)}
            alt=""
            className="mod-evaluate__value-img"
          />
          <span className="mod-evaluate__value-text">
            {props.confirmRateText}
          </span>
        </div>
      </div>
      <div className="space-side__owner-eval-innner-list col-xs-4">
        <h4 className="mod-evaluate__title">{i18n.t('page.room.evalute2')}</h4>
        <div className="mod-evaluate__value">
          <img
            src={ownerEvalutionImage(props.replyRateEvaluation)}
            alt=""
            className="mod-evaluate__value-img"
          />
          <span className="mod-evaluate__value-text">
            {props.replyRateText}
          </span>
        </div>
      </div>
      <div className="space-side__owner-eval-innner-list col-xs-4">
        <h4 className="mod-evaluate__title">{i18n.t('page.room.evalute3')}</h4>
        <div className="mod-evaluate__value">
          <img
            src={ownerEvalutionImage(props.replyTimeAvgEvaluation)}
            alt=""
            className="mod-evaluate__value-img"
          />
          <span className="mod-evaluate__value-text">
            {props.replyTimeAvgText}
          </span>
        </div>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/organisms/OwnerEvaluate/index.jsx